module.exports = __webpack_public_path__ + "static/fonts/Recta.4c03c15.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Recta.woff
// module id = 335
// module chunks = 0